<template>
    <van-dialog v-model="remarkPopupStatus" width="280px" :confirm-button-text="$t('Understood')">
        <div class="remark-popup-content">
            <div class="text">{{ $t('longPressTip') }}</div>
        </div>
    </van-dialog>
</template>

<script>
export default {
    name: 'RemarkPopup',
    props: {
        show: Boolean,
    },
    computed: {
        remarkPopupStatus: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('update:show', val)
            },
        },
    },
    methods: {},
}
</script>

<style scoped lang="less">
.remark-popup-content {
    padding: 28px 16px;

    .text {
        color: #181818;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0%;
    }
}
</style>
